module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[37]158.9e0632a.woff2";